exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Footer-container {\n  display: flex;\n  justify-content: center; }\n\n.Footer-subcontainer {\n  width: 90%; }\n\n.Footer-block {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  width: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Marginals/Footer.scss
// module id = 112
// module chunks = 0